import SuperFetch, { AbortSuperFetch } from '../helpers/superFetch';
import UrlBuilder from '../helpers/urlBuilder';
import { getAttributes } from '../helpers/urlBuilder';

const { build } = UrlBuilder;
type ApiReqWithParam = (params: getAttributes) => Promise<Response>;
type ApiReqWNoParam = () => Promise<Response>;

/**
 * Klasa zawiera metody służące wysyłaniu zapytań o dane dotyczące kart przedmiotów do API
 *
 * */
class SubjectsCards {
  /** Pobieranie danych dla tabeli w zakładce "Karty Przedmiotów"*/
  getSubjectsCards = ({ page, columns, sort, orderBy, limit = '300', filter, search, isWKD }: getAttributes, signal?: AbortSignal): Promise<Response> => {
    const params: getAttributes = {
      page: page.toString(),
      columns,
      limit,
      orderBy,
      sort,
      filter,
      search,
      isWKD,
    };
    const address: string = build('kp/ztn-karta-przedmiotu-list', params);
    return signal ? AbortSuperFetch.get(address, signal) : SuperFetch.get(address);
  };
  /** Pobieranie szczegółów o karcie przedmiotu */
  getSubjectCardData: ApiReqWithParam = ({ id, columns }) => {
    const params: getAttributes = {
      columns,
    };
    const address: string = build(`kp/karta_przedmiotu_opis/${id}`, params);
    return SuperFetch.get(address);
  };
  /** pobranie jednej karty przedmiotu  */
  getSubjectCardDetails: ApiReqWithParam = ({ filter, columns, limit = '1' }) => {
    const params: getAttributes = {
      filter,
      columns,
      limit,
    };
    const address: string = build(`kp/ztn-karta-przedmiotu-list`, params);
    return SuperFetch.get(address);
  };
  /** Pobieranie konfiguracji kolumn dla tabeli "Karty Przedmiotów" */
  getSubjectsCardsColumnsData: ApiReqWNoParam = () =>
    SuperFetch.get(`kp/ztn-karta-przedmiotu-config`);
  /** Aktualizacja konfiguracji kolumn dla tabeli "Karty Przedmiotów"*/
  saveColumnsUserSetup: ApiReqWithParam = ({ columnsSetup }) => {
    const payload = {
      data: JSON.stringify(columnsSetup),
    };
    return SuperFetch.put('uc/user-config/cs_kp', payload);
  }
  /** pobranie listy programów studiów */
  getStudyPrograms: ApiReqWithParam = ({ filter, columns, limit = '100' }) => {
    const params: getAttributes = {
      filter,
      columns,
      limit,
    };
    const address: string = build(`kp/progr-stud-list-for-user`, params);
    return SuperFetch.get(address);
  };
  /** pobranie listy efektów kierunkowych  */
  getLearningEffects: ApiReqWithParam = ({ filter, columns }) => {
    const params: getAttributes = {
      filter,
      columns,
    };
    const address: string = build(`kp/progr-stud-efekty-kier-lista`, params);
    return SuperFetch.get(address);
  };
  /** pobranie listy sprawoanych z przedmiotem efektów kierunkowych  */
  getAlreadyPairedEffects: ApiReqWithParam = ({ filter, columns }) => {
    const params: getAttributes = {
      filter,
      columns,
    };
    const address: string = build(`kp/efekty-kier-pared-przedm-lista`, params);
    return SuperFetch.get(address);
  }
  /** zapis w tabeli tymczasowej  */
  saveEffectsInTemporaryTable: ApiReqWithParam = params => {
    return SuperFetch.post(`kp/temp-table-data`, params);
  };
  /** publikacja efektów kierunkowych  */
  publishLearningEffects: ApiReqWithParam = params => {
    return SuperFetch.post(`kp/efekt-kierunku-sparuj-z-przedmiotem`, params);
  };
}

export default new SubjectsCards();
